"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "handleRemoteVideoSourcesDidChange", {
  enumerable: true,
  get: function get() {
    return _handleRemoteVideoSourcesDidChange.handleRemoteVideoSourcesDidChange;
  }
});
Object.defineProperty(exports, "videoPriorityBasedPolicyMiddleware", {
  enumerable: true,
  get: function get() {
    return _videoPriorityBasedPolicyMiddleware.videoPriorityBasedPolicyMiddleware;
  }
});
var _handleRemoteVideoSourcesDidChange = require("./handleRemoteVideoSourcesDidChange");
var _videoPriorityBasedPolicyMiddleware = require("./videoPriorityBasedPolicyMiddleware");